/* AOT theme scripts: drawers, collection filters, product variants, release + holder bundle. */
(function () {
  'use strict';

  /* Drawers (mobile menu, mobile filters) */
  var lastTrigger = null;
  function openDrawer(el, trigger) {
    lastTrigger = trigger || null;
    el.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    var focusable = el.querySelector('input, button, a, select');
    if (focusable) focusable.focus();
  }
  function closeDrawer(el) {
    el.removeAttribute('open');
    document.documentElement.style.overflow = '';
    if (lastTrigger) lastTrigger.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) { e.preventDefault(); openDrawer(target, opener); }
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      var drawer = closer.closest('[data-drawer]');
      if (drawer) closeDrawer(drawer);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-drawer][open]').forEach(closeDrawer);
  });

  /* Collection filters submit on change; sort updates the URL */
  document.querySelectorAll('form[data-auto-submit]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 250);
    });
  });
  document.querySelectorAll('select[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Product page */
  var section = document.querySelector('[data-product-section]');
  if (!section) return;
  var json = section.querySelector('[data-product-json]');
  var product;
  try { product = JSON.parse(json.textContent); } catch (err) { return; }

  var form = document.getElementById('ProductForm');
  var idInput = section.querySelector('[data-variant-id]');
  var priceEl = section.querySelector('[data-price]');
  var compareEl = section.querySelector('[data-compare]');
  var addBtn = section.querySelector('[data-add]');
  var addLabel = section.querySelector('[data-add-label]');
  var errorEl = section.querySelector('[data-error]');
  var fieldsets = section.querySelectorAll('[data-option-index]');
  var current = product.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || product.variants[0];

  function formatMoney(cents) {
    var format = product.money_format || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return withCommas;
      if (key === 'amount_with_comma_separator') return withCommas.replace(/,/g, '.') + ',' + parts[1];
      if (key === 'amount_no_decimals_with_comma_separator') return withCommas.replace(/,/g, '.');
      return withCommas + '.' + parts[1];
    });
  }

  function selectedOptions() {
    return Array.prototype.map.call(fieldsets, function (fs) {
      var checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function markAvailability(selected) {
    fieldsets.forEach(function (fs, index) {
      fs.querySelectorAll('input').forEach(function (input) {
        var trial = selected.slice();
        trial[index] = input.value;
        var ok = product.variants.some(function (v) {
          return v.available && v.options.every(function (o, i) { return o === trial[i]; });
        });
        var label = fs.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !ok);
      });
    });
  }

  function onVariantChange() {
    var selected = selectedOptions();
    var match = product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    })[0];
    markAvailability(selected);
    if (errorEl) errorEl.hidden = true;
    if (!match) {
      addBtn.disabled = true;
      addLabel.textContent = 'Unavailable';
      return;
    }
    current = match;
    idInput.value = match.id;
    priceEl.textContent = match.price_formatted;
    if (match.compare_formatted) { compareEl.textContent = match.compare_formatted; compareEl.hidden = false; }
    else { compareEl.hidden = true; }
    addBtn.disabled = !match.available;
    addLabel.textContent = match.available ? 'Add to cart — ' + match.price_formatted : 'Sold out';
    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());
    if (match.media_id) showVariantMedia(match.media_id, true);
    updateBundle();
  }

  /* Variant photo. Mobile: slide the carousel to it.
     Desktop: swap it into the large top slot so it's clear which photo is the selected one. */
  var desktopMq = window.matchMedia('(min-width: 990px)');
  var BIG_SIZES = '(min-width: 990px) 55vw, 100vw';
  var SMALL_SIZES = '(min-width: 990px) 27vw, 100vw';
  function showVariantMedia(mediaId, scroll) {
    var item = section.querySelector('[data-media-id="' + mediaId + '"]');
    if (!item) return;
    if (!desktopMq.matches) {
      if (scroll) item.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'smooth' });
      return;
    }
    var list = item.parentNode;
    var first = list.querySelector('.pdp__media-item.is-first');
    if (first !== item) {
      if (first) {
        first.classList.remove('is-first');
        first.querySelectorAll('img').forEach(function (img) { img.sizes = SMALL_SIZES; });
      }
      list.insertBefore(item, list.firstChild);
      item.classList.add('is-first');
      item.querySelectorAll('img').forEach(function (img) {
        img.loading = 'eager';
        /* Add a sharper 1400px source for the large slot */
        if (img.srcset && img.srcset.indexOf(' 1400w') === -1) {
          var m = img.srcset.match(/(\S*width=1000\S*)\s+1000w/);
          if (m) img.srcset = img.srcset + ', ' + m[1].replace('width=1000', 'width=1400') + ' 1400w';
        }
        img.sizes = BIG_SIZES;
      });
    }
    if (scroll) {
      var top = list.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.4) {
        window.scrollTo({ top: window.pageYOffset + top - 20, behavior: 'smooth' });
      }
    }
  }
  /* Arriving on a link to a specific variant: show its photo up top */
  if (new URL(window.location.href).searchParams.get('variant') && current.media_id) {
    showVariantMedia(current.media_id, false);
  }
  fieldsets.forEach(function (fs) { fs.addEventListener('change', onVariantChange); });
  if (fieldsets.length) markAvailability(selectedOptions());

  /* Mobile gallery dots */
  var gallery = section.querySelector('[data-gallery]');
  var dots = section.querySelectorAll('.pdp__dots span');
  if (gallery && dots.length) {
    gallery.addEventListener('scroll', function () {
      var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }, { passive: true });
  }

  /* Add to cart via AJAX, then go to the cart */
  function addItems(items, button) {
    button.disabled = true;
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart');
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      });
    }).catch(function (err) {
      button.disabled = false;
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
    });
  }

  /* Release + holder bundle */
  var holderBox = section.querySelector('[data-holder]');
  function selectedHolder() {
    return holderBox && holderBox.querySelector('input[name="holder-variant"]:checked');
  }
  function updateBundle() {
    if (!holderBox) return;
    var h = selectedHolder();
    var bundle = holderBox.querySelector('.holder__bundle');
    var savings = parseInt(bundle.getAttribute('data-savings-cents'), 10) || 0;
    var full = current.price + (h ? parseInt(h.getAttribute('data-price-cents'), 10) : 0);
    holderBox.querySelector('[data-bundle-price]').textContent = formatMoney(full - savings);
    holderBox.querySelector('[data-bundle-full]').textContent = formatMoney(full);
    holderBox.querySelector('[data-add-both]').disabled = !current.available || !h;
  }
  if (holderBox) {
    holderBox.addEventListener('change', updateBundle);
    holderBox.querySelector('[data-add-both]').addEventListener('click', function (e) {
      var h = selectedHolder();
      if (!h) return;
      addItems([{ id: current.id, quantity: 1 }, { id: parseInt(h.value, 10), quantity: 1 }], e.currentTarget);
    });
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      addItems([{ id: current.id, quantity: 1 }], addBtn);
    });
  }
})();
